import { useMemo } from "react";
import { CroppingPatternReportModel } from "@agroyaar/sdk";
import LineChart from "@/shared/components/charts/LineChart";
import Title from "@/shared/components/report-template/presentation/components/common/Title";
import ReportTemplate from "@/shared/components/report-template/presentation/components/ReportTemplate";
import { Table } from "@/shared/components/report-template/presentation/components/common/Table";
import { averagesGddColumns } from "@/features/reports/presentation/components/cropping-pattern/constants/average-gdd-header-table";

interface AveragesGddProps {
  croppingPatternReports: CroppingPatternReportModel[];
  chartYears: string[];
}

const AveragesGdd = ({
  croppingPatternReports,
  chartYears,
}: AveragesGddProps) => {
  const series = useMemo(
    () =>
      croppingPatternReports.map(
        ({ crop, annuallySuppliedGrowingDegreeDay }) => ({
          name: crop.persianName,
          data: annuallySuppliedGrowingDegreeDay.map(({ value }) => value),
        })
      ),
    [croppingPatternReports]
  );

  return (
    <ReportTemplate serviceType="CROPPING_PATTERN" pageNumber={7}>
      <div className="w-full flex flex-col justify-between gap-3">
        <div className="w-full flex flex-col gap-2">
          <Title>درجه روز رشد تامین شده سالانه (GDD)</Title>
          <div className="w-full flex flex-col justify-center items-center gap-2 my-5">
            <LineChart
              yAxisTitle="درجه روز رشد (GDD)"
              labelsFontSize="10px"
              xAxisLabelsOptionsStep={1}
              categories={chartYears}
              series={series}
            />
            <Title>
              مقدار واحد دمایی محاسبه شده برای طول فصل در طی 30 سال گذشته
            </Title>
          </div>
        </div>
        <div className="w-full flex flex-col gap-2 mt-8">
          <Title>
            مقایسه میانگین GDD تامین شده در 30 سال گذشته با GDD مورد نیاز برای
            هر محصول
          </Title>

          <Table columns={averagesGddColumns} data={croppingPatternReports} />
        </div>
      </div>
    </ReportTemplate>
  );
};

export default AveragesGdd;
